import { render, staticRenderFns } from "./bestUSA.vue?vue&type=template&id=a35e7c56&"
import script from "./bestUSA.vue?vue&type=script&lang=js&"
export * from "./bestUSA.vue?vue&type=script&lang=js&"
import style0 from "./bestUSA.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports